import { StyleSheet, Text, useWindowDimensions, View } from 'react-native'
import React, { useEffect, useRef } from 'react'
import { Video, AVPlaybackStatus } from 'expo-av';
import ReactHlsPlayer from "react-hls-player";
import { LinearGradient } from 'expo-linear-gradient';
import { colors } from '../../colors';

const VideoBackground = ({videoUrl, muted = true, controls = false, cover = false}) => {
  const window = useWindowDimensions();
  const video = useRef();

  useEffect(() => {
    const node = video.current
    if (!node || !videoUrl) return
    const start = () => {
      const attempt = node.play?.()
      if (attempt && attempt.catch) {
        attempt.catch(() => {
          node.muted = true
          node.play?.()
        })
      }
    }
    const videoNode = node.tagName === 'VIDEO' ? node : node.querySelector?.('video') || node
    const fitCover = () => {
      if (!cover || !videoNode?.style) return
      const frame = videoNode.parentElement
      if (frame?.style) {
        frame.style.setProperty('position', 'fixed', 'important')
        frame.style.setProperty('inset', '0', 'important')
        frame.style.setProperty('width', '100vw', 'important')
        frame.style.setProperty('height', '100dvh', 'important')
        frame.style.setProperty('overflow', 'hidden', 'important')
        frame.style.setProperty('z-index', '0', 'important')
        frame.style.setProperty('background', 'transparent', 'important')
      }
      videoNode.removeAttribute('width')
      videoNode.removeAttribute('height')
      videoNode.style.setProperty('position', 'absolute', 'important')
      videoNode.style.setProperty('width', '100%', 'important')
      videoNode.style.setProperty('height', '100%', 'important')
      videoNode.style.setProperty('max-width', 'none', 'important')
      videoNode.style.setProperty('max-height', 'none', 'important')
      videoNode.style.setProperty('left', '0', 'important')
      videoNode.style.setProperty('top', '0', 'important')
      videoNode.style.setProperty('object-fit', 'cover', 'important')
      videoNode.style.setProperty('object-position', 'center center', 'important')
      videoNode.style.setProperty('transform', 'scale(1.55)', 'important')
      videoNode.style.setProperty('transform-origin', 'center center', 'important')
    }
    if (cover) {
      fitCover()
      videoNode.addEventListener?.('loadedmetadata', fitCover)
      globalThis.window.addEventListener('resize', fitCover)
    }
    if (controls) {
      start()
      return () => {
        videoNode.removeEventListener?.('loadedmetadata', fitCover)
        globalThis.window.removeEventListener('resize', fitCover)
      }
    }
    const timer = setTimeout(start, 400)
    return () => {
      clearTimeout(timer)
      videoNode.removeEventListener?.('loadedmetadata', fitCover)
      globalThis.window.removeEventListener('resize', fitCover)
    }
  }, [videoUrl, controls, cover])

  if (!videoUrl) return null

  return (
    <View pointerEvents="none" style={[styles.container, cover && styles.cover, !cover && {width: window.width, height: window.height}]}>
      <ReactHlsPlayer
        src={`https://ivyooo.com/assets/trailers/${videoUrl}/hls/${videoUrl}.m3u8`}
        autoPlay={true}
        controls={controls}
        loop
        playsInline
        muted={muted}
        playerRef={video}
        style={cover ? styles.coverVideo : { height: window.height, width: window.width }}
      />
     {!controls && !cover && <><LinearGradient
        // Background Linear Gradient
        colors={[colors.background, colors.background, 'transparent']}
        style={[styles.background, { height: window.height / 3 }]} /><LinearGradient
          // Background Linear Gradient
          colors={['transparent', colors.background, colors.background]}
          style={[styles.backgroundBot, { height: window.height / 3 }]} /></>}
      {/* <Video
        ref={video}
        style={[styles.video]}
        videoStyle={{width: '100%', height: '100%'}}
        // usePoster
        // posterStyle={{width: '100%', height: '100%', resizeMode: 'cover'}}
        // posterSource={{uri: `https://ivyooo.com/assets/images/${posterUrl}`}}
        source={{
          uri : 'https://d23dyxeqlo5psv.cloudfront.net/big_buck_bunny.mp4',
        }}
        shouldPlay={true}
        // onPlaybackStatusUpdate={status => setStatus(() => status)}
        // onReadyForDisplay={updateVideoRatioOnDisplay}
      /> */}
    </View>
  )
}

export default VideoBackground

const styles = StyleSheet.create({
    container: {
        flex: 1,
        position: 'absolute',
        backgroundColor: colors.background
    },
    cover: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        backgroundColor: 'transparent',
    },
    coverVideo: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    video: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    background: {
        width: '100%',
        position: 'absolute',
        top: 0,
    },
    backgroundBot: {
        width: '100%',
        position: 'absolute',
        bottom: 0,
    },
})